<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader data-testid="dashboard-header" />
    <v-row>
      <v-col
        :cols="mobile() ? 11 : 4"
        class="d-flex justify-end mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
        />
      </v-col>
    </v-row>
    <ListGridViewMode v-if="role == 'booster' || role == 'space_admin'" @toggleView="toggleView" :class="mobile() ? '' : 'mt-n16'" />
    <v-row
      v-if="(hubs.length == 0 && activities.length == 0) && !loadingData && mobile()"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyDashboardTitle')"
          :page-text="$t('emptyDashboardText')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="(hubs.length == 0 && activities.length == 0) && !loadingData && !mobile()"
      align="center"
    >
      <v-col
        align="center"
        offset-sm="1"
        offset-md="1"
        :cols="mobile() ? '12' : '5'"
        :class="mobile() ? '' : 'pr-16 my-10'"
      >
        <CreateContentTemplate
          data-testid="create-activity"
          :page-title="$t('createContentTemplateTitleActivity')"
          :page-text="$t('createContentTemplateTextActivity')"
          page-image="create-activity"
          :page-create-btn="$t('create')"
          @proceedSubmit="createActivity"
        />
      </v-col>
      <v-divider vertical />
      <v-col
        align="center"
        :cols="mobile() ? '12' : '5'"
        :class="mobile() ? '' : 'pl-16 my-10'"
      >
        <CreateContentTemplate
          data-testid="create-hub"
          :page-title="$t('createContentTemplateTitleHub')"
          :page-text="$t('createContentTemplateTextHub')"
          page-image="create-hub"
          :page-create-btn="$t('create')"
          @proceedSubmit="createHub"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hubs.length > 0 && !loadingData"
      data-testid="hubs-list"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row>
          <v-col
            cols="6"
            class="d-flex justify-start align-center"
          >
            <p class="text-h5 mb-0 font-weight-bold">
              {{ $t('hubs') }}
            </p>
          </v-col>
          <v-col
            v-if="hubs.length > 3"
            data-testid="hubs-list-show-all"
            cols="6"
            class="d-flex justify-end  align-center"
          >
            <a @click="showhubPage">{{ $t('seeAll') }}
            </a>
          </v-col>
        </v-row>
        <v-row v-if="view == 'grid-view'" align="center" data-testid="grid-view">
          <v-col
            v-for="item in hubs.slice(0,3)"
            :key="item.id"
            cols="12"
            sm="6"
            xl="4"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="280"
                data-testid="hub-card"
                rounded="xxl" 
                class="mx-auto"
                :ripple="false"                        
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`" 
                :to="'/hub/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')"
                    height="120px"
                  >
                    <v-card-text class="py-5">
                      <v-row
                        no-gutters
                        class="mx-auto "
                      >
                        <v-col
                          class="d-flex align-start ml-2"
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-chip
                                small
                                data-testid="sharing-setting-chip"
                                color="darktext"
                                text-color="white"
                                filter-icon="mdi-equalizer-outline"
                                class="mr-4"
                                v-on="on"
                              >
                                <v-icon
                                  size="14"
                                  class="pr-1"
                                >
                                  mdi-share-variant
                                </v-icon>
                                <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                              </v-chip>
                            </template>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                          </v-tooltip>
                          <v-chip
                            small
                            color="accent"
                          >
                            <span class="text-uppercase">{{ $t('hub') }}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-img>
                </v-responsive>
                <v-card-text class="pa-0">
                  <v-row no-gutters>
                    <v-col
                      cols="11"
                      sm="11"
                      md="11"
                      class="py-0"
                    >
                      <v-card-title
                        class="text-left no-break darktext--text"
                        style="line-height:inherit"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="1"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      v-if="item.attributes.is_owner || item.attributes.role == 'booster'"
                      class="d-flex justify-end"
                      cols="1"
                      sm="1"
                      md="1"
                    >
                      <v-card-actions class="pa-1">
                        <v-menu class="float-right">
                          <template v-slot:activator="{  on: { click }, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on:click.stop.prevent="click"
                            >
                              <v-icon
                                large
                                class="darktext--text"
                                data-testid="threedots-icon"
                              >
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list data-testid="menu-list-actions">
                            <v-list-item 
                              router 
                              data-testid="analytics-icon-hub"
                              @click.stop="openPeopleInHub(item.id)"
                            >
                              <v-list-item-title> {{ $t('analytics') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="edit-hub"
                              router 
                              @click.stop="openHubSettingsDialog(item)"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="remove-hub"
                              router 
                              @click.stop="
                                selectedHubForDeletion = item.id,
                                dialogVisibleRemoveHub = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveHub'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveHub'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteHub') }} </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-actions>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                    >
                      <v-card-subtitle class="text-left no-break text-body-1 greytext--text darktext--text py-0">
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ item.attributes.description }}
                        </v-clamp>
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-card v-if="view == 'list-view'" elevation="0" class="pa-3 rounded-xxl base-background" data-testid="list-view">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <span class="text-body-1 font-weight-bold">{{ $t('title') }}</span>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('status') }}</span>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('analytics') }}</span>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-end">
                    <span class="text-body-1 font-weight-bold">{{ $t('more') }}   </span>        
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
            <v-col cols="12" v-for="(item, index) in hubs" :key="item.id">
              <v-card :rounded="false" class="pa-1 elevation-0 base-background" :to="'/hub/'+item.id">
                <v-row no-gutters class="row-pointer">
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <v-img class="rounded-xl" :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')" max-width="80" height="52"></v-img>
                    <v-card-title class="text-left no-break darktext--text text-body-1">
                      <v-clamp
                        autoresize
                        :max-lines="1"
                      >
                        {{ item.attributes.title }}
                      </v-clamp>
                    </v-card-title>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip
                          small
                          data-testid="sharing-setting-chip"
                          color="darktext"
                          text-color="white"
                          filter-icon="mdi-equalizer-outline"
                          v-on="on"
                          class="mx-auto"
                        >
                          <v-icon
                            size="14"
                            class="pr-1"
                          >
                            mdi-share-variant
                          </v-icon>
                          <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                          <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                        </v-chip>
                      </template>
                      <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                      <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <v-tooltip
                      bottom
                      data-testid="analytics-icon"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="d-flex justify-center mx-auto"
                          v-bind="attrs"
                          icon
                          @click.stop.prevent="openPeopleInHub(item.id)"
                          v-on="on"
                        >
                          <v-icon
                            size="22px"
                            class="darktext--text"
                          >
                            mdi-equalizer-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('analyticsInHubTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="item.attributes.is_owner || item.attributes.role == 'booster'" cols="1" class="d-flex justify-end">
                    <v-card-actions class="pa-1">
                      <v-menu class="float-right">
                        <template v-slot:activator="{  on: { click }, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on:click.stop.prevent="click"
                          >
                            <v-icon
                              large
                              class="darktext--text"
                              data-testid="threedots-icon"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list data-testid="menu-list-actions">
                          <v-list-item 
                            router 
                            data-testid="analytics-icon-hub"
                            @click.stop="openPeopleInHub(item.id)"
                          >
                            <v-list-item-title> {{ $t('analytics') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            data-testid="edit-hub"
                            router 
                            @click.stop="openHubSettingsDialog(item)"
                          >
                            <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            data-testid="remove-hub"
                            router 
                            @click.stop="
                              selectedHubForDeletion = item.id,
                              dialogVisibleRemoveHub = true, 
                              confirmationDialogTitle = $t('confirmationDialogTitleRemoveHub'), 
                              confirmationDialogText = $t('confirmationDialogTextRemoveHub'), 
                              confirmationDialogSubmitBtn = $t('delete')
                              confirmationDialogCancelBtn = $t('no')"
                          >
                            <v-list-item-title> {{ $t('deleteHub') }} </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-actions>           
                  </v-col>
                </v-row>
              </v-card>
              <v-divider v-if="index < hubs.length - 1"></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>  
    </v-row> 

    <v-row
      v-if="activities.length > 0 && !loadingData"
      data-testid="activities-list"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row>
          <v-col
            cols="6"
            class="d-flex justify-start"
          >
            <p class="text-h5 mb-0 font-weight-bold">
              {{ $t('activitiesItem') }}
            </p>
          </v-col>
          <v-col
            v-if="activities.length > 4"
            data-testid="activities-list-show-all"
            cols="6"
            class="d-flex justify-end"
          >
            <a @click="showActivityPage">{{ $t('seeAll') }}
            </a>
          </v-col>
        </v-row>
        <v-row v-if="view == 'grid-view'" align="center" data-testid="grid-view">
          <v-col
            v-for="item in activities.slice(0,4)"
            :key="item.id"
            cols="12"
            sm="6"
            lg="4"
            xl="3"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="345"
                data-testid="activity-card"
                rounded="xxl" 
                class="mx-auto"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
                :to="'/activity/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/cover-activity.jpg')"
                    height="195px"
                  />
                </v-responsive>
                <v-card-text class="pa-0" style="height: 80px;">
                  <v-row>
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      class="py-0"
                    >
                      <v-card-title class="text-left darktext--text no-break px-4 py-2">
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      v-if="item.attributes.is_owner || item.attributes.role == 'booster'"
                      class="pl-0"
                      cols="2"
                      sm="2"
                      md="2"
                    >
                      <v-card-actions class="px-0 pb-6 pt-0 d-flex justify-center">
                        <v-menu class="float-right">
                          <template v-slot:activator="{  on: { click }, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on:click.stop.prevent="click"
                            >
                              <v-icon
                                large
                                class="darktext--text"
                                data-testid="threedots-icon"
                              >
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list data-testid="menu-list-actions">
                            <v-list-item
                              data-testid="duplicate-activity"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleDuplicateActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleDuplicateActivity'), 
                                confirmationDialogText = $t('confirmationDialogTextDuplicateActivity'), 
                                confirmationDialogSubmitBtn = $t('duplicate')
                                confirmationDialogCancelBtn = $t('cancel')"
                            >
                              <v-list-item-title> {{ $t('duplicateActivity') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="create-activity-template"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleCreateTemplateFromActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleCreateTemplate'), 
                                confirmationDialogText = $t('confirmationDialogTextCreateTemplate'), 
                                confirmationDialogSubmitBtn = $t('create')
                                confirmationDialogCancelBtn = $t('cancel')"
                                :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
                            >
                              <v-list-item-title> {{ $t('saveAsTemplate') }} 
                                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg ml-2 px-2" x-small color="accent" text-color="white">PRO</v-chip>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="edit-activity"
                              router 
                              @click="openActivitySettingsDialog(item)"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="remove-activity"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleRemoveActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveActivity'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveActivity'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteActivity') }} </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0" style="height: 70px;">
                  <v-row
                    v-if="item.attributes.is_owner || item.attributes.role == 'booster'"
                    class="mx-auto fill-height"
                  >
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      class="d-flex align-end pa-4"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-chip
                            small
                            data-testid="sharing-setting-chip"
                            color="darktext"
                            text-color="white"
                            filter-icon="mdi-equalizer-outline"
                            v-on="on"
                          >
                            <v-icon
                              size="14"
                              class="pr-1"
                            >
                              mdi-share-variant
                            </v-icon>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexible') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                          </v-chip>
                        </template>
                        <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexibleTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenTooltip') }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      cols="2"
                      sm="2"
                      md="2"
                      class="d-flex pl-2 pr-0 align-end"
                    >
                      <v-tooltip
                        bottom
                        data-testid="analytics-icon"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="d-flex justify-center"
                            v-bind="attrs"
                            icon
                            @click.stop.prevent="openPeopleInActivity(item.id)"
                            v-on="on"
                          >
                            <v-icon
                              size="22px"
                              class="darktext--text"
                            >
                              mdi-equalizer-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('analyticsInActivityTooltip') }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="item.attributes.role != 'booster'"
                    class="mx-auto pa-4 fill-height align-end"
                  >
                    <v-progress-linear :value="item.meta.statistics.data.percentage" :color="item.meta.statistics.data.percentage == 0 ? 'greytextlight' : 'success'" height="16" class="rounded-xxl" data-testid="progress-linear"><span class="text-caption">{{ item.meta.statistics.data.percentage }}%</span></v-progress-linear>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-card v-if="view == 'list-view'" elevation="0" class="pa-3 rounded-xxl base-background" data-testid="list-view">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <span class="text-body-1 font-weight-bold">{{ $t('title') }}</span>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('status') }}</span>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <span class="text-body-1 font-weight-bold mx-auto">{{ $t('analytics') }}</span>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-end">
                    <span class="text-body-1 font-weight-bold">{{ $t('more') }}   </span>        
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
            <v-col cols="12" v-for="(item, index) in activities" :key="item.id">
              <v-card :rounded="false" class="pa-1 elevation-0 base-background" :to="'/activity/'+item.id">
                <v-row no-gutters class="row-pointer">
                  <v-col cols="11" sm="6" class="d-flex align-center">
                    <v-img class="rounded-xl" :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')" max-width="80" height="52"></v-img>
                    <v-card-title class="text-left no-break darktext--text text-body-1">
                      <v-clamp
                        autoresize
                        :max-lines="1"
                      >
                        {{ item.attributes.title }}
                      </v-clamp>
                    </v-card-title>
                  </v-col>
                  <v-col cols="3" class="align-center d-none d-sm-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip
                          small
                          data-testid="sharing-setting-chip"
                          color="darktext"
                          text-color="white"
                          filter-icon="mdi-equalizer-outline"
                          v-on="on"
                          class="mx-auto"
                        >
                          <v-icon
                            size="14"
                            class="pr-1"
                          >
                            mdi-share-variant
                          </v-icon>
                          <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                          <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexible') }}</span>
                          <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                        </v-chip>
                      </template>
                      <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedTooltip') }}</span>
                      <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexibleTooltip') }}</span>
                      <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" class="align-center d-none d-sm-flex">
                    <v-tooltip
                      bottom
                      data-testid="analytics-icon"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="d-flex justify-center mx-auto"
                          v-bind="attrs"
                          icon
                          @click.stop.prevent="openPeopleInActivity(item.id)"
                          v-on="on"
                        >
                          <v-icon
                            size="22px"
                            class="darktext--text"
                          >
                            mdi-equalizer-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('analyticsInActivityTooltip') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="item.attributes.is_owner || item.attributes.role == 'booster'" cols="1" class="d-flex justify-end">
                    <v-card-actions class="pa-1">
                      <v-menu class="float-right">
                        <template v-slot:activator="{  on: { click }, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on:click.stop.prevent="click"
                          >
                            <v-icon
                              large
                              class="darktext--text"
                              data-testid="threedots-icon"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list data-testid="menu-list-actions">
                          <v-list-item
                              data-testid="duplicate-activity"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleDuplicateActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleDuplicateActivity'), 
                                confirmationDialogText = $t('confirmationDialogTextDuplicateActivity'), 
                                confirmationDialogSubmitBtn = $t('duplicate')
                                confirmationDialogCancelBtn = $t('cancel')"
                            >
                              <v-list-item-title> {{ $t('duplicateActivity') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="create-activity-template"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleCreateTemplateFromActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleCreateTemplate'), 
                                confirmationDialogText = $t('confirmationDialogTextCreateTemplate'), 
                                confirmationDialogSubmitBtn = $t('create')
                                confirmationDialogCancelBtn = $t('cancel')"
                                :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
                            >
                              <v-list-item-title> {{ $t('saveAsTemplate') }} 
                                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg ml-2 px-2" x-small color="accent" text-color="white">PRO</v-chip>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="edit-activity"
                              router 
                              @click="openActivitySettingsDialog(item)"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              data-testid="remove-activity"
                              router 
                              @click.stop="
                                selectedActivityItem = item,
                                dialogVisibleRemoveActivity = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveActivity'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveActivity'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteActivity') }} </v-list-item-title>
                            </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-actions>           
                  </v-col>
                </v-row>
              </v-card>
              <v-divider v-if="index < activities.length - 1"></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>  
    </v-row>

    <v-fab-transition v-if="!mobile()">
      <v-tooltip
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="create-activity-hub"
            data-testid="create-content-template"
            color="accent"
            fixed
            right
            bottom
            fab
            large
            @click.stop="
              dialogVisibleCreateContentTemplate = true "
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('createContent') }}</span>
      </v-tooltip>
    </v-fab-transition>
        <ConfirmationDialogWithOutSubmitBtn
      v-if="showConfirmationDialog"
      ref="showConfirmationDialog"
      :visible="showConfirmationDialog"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      data-testid="confirmation-dialog-can-not-delete"
      @close="showConfirmationDialog = false"
    />

    <ConfirmationDialog
      v-if="dialogVisibleRemoveActivity"
      ref="confirmationDialogRemoveActivity"
      :visible="dialogVisibleRemoveActivity"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-activity"
      @close="dialogVisibleRemoveActivity = false"
      @proceedSubmit="removeActivity(selectedActivityItem.id)"
    /> 
    <ConfirmationDialogDuplicateActivity
      v-if="dialogVisibleDuplicateActivity"
      :visible="dialogVisibleDuplicateActivity"
      :cd-title="confirmationDialogTitle"
      cd-text=""
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :title="selectedActivityItem.attributes.title"
      :loading="loadingDuplicateProcess" 
      data-testid="confirmation-dialog-duplicate-activity" 
      @close="dialogVisibleDuplicateActivity=false"
      @proceedSubmit="duplicateActivity"
    />
    <ConfirmationDialog
      v-if="dialogVisibleRemoveHub"
      ref="confirmationDialogRemoveHub"
      :visible="dialogVisibleRemoveHub"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-hub"
      @close="dialogVisibleRemoveHub = false"
      @proceedSubmit="removeHub(selectedHubForDeletion)"
    />

    <ConfirmationDialogCreateTemplate
      v-if="dialogVisibleCreateTemplateFromActivity"
      :id="selectedActivityItem.id"
      :visible="dialogVisibleCreateTemplateFromActivity"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-create-template"
      @close="dialogVisibleCreateTemplateFromActivity=false"
      @proceedSubmit="createTemplate"
    />

    <CreateContentTemplateDialog 
      v-if="dialogVisibleCreateContentTemplate"
      ref="confirmationDialogRemoveHub"
      :visible="dialogVisibleCreateContentTemplate" 
      data-testid="create-content-template-dialog" 
      @close="dialogVisibleCreateContentTemplate = false"
      @proceedSubmit="createContentMsg"
    />

    <ConfirmationDialogCreateActivity 
      v-if="dialogVisibleCreateActivity"
      :visible="dialogVisibleCreateActivity" 
      data-testid="create-activity" 
      @close="dialogVisibleCreateActivity = false"
      @proceedSubmit="createActivityMsg"
    />

    <EditActivity
      v-if="selectedActivityItem.attributes && selectedActivityItem.attributes.role == 'booster' && visibleDialogActivitySettingsDialog && !mobile()"
      :visible="visibleDialogActivitySettingsDialog"
      :activity-id="selectedActivityItem.id"
      :activity-title="selectedActivityItem.attributes.title"
      :activity-image-u-r-l="selectedActivityItem.attributes.image"
      :activity-image-path="null"
      :activity-sharing-settings="selectedActivityItem.relationships['sharing-setting'].data.id"
      :activity-checkbox-forum="selectedActivityItem.attributes.forum_enabled"
      :activity-checkbox-certificate="selectedActivityItem.attributes.certificate_enabled"
      :activity-tags="selectedActivityItem.attributes.tags"
      @close="visibleDialogActivitySettingsDialog= false"
      @proceedSubmit="updateActivity"
    />
    
    <EditHub
      v-if="selectedHubItem.attributes && selectedHubItem.attributes.role == 'booster' && visibleDialogHubSettingsDialog && !mobile()"
      :visible="visibleDialogHubSettingsDialog"
      :hub-id="selectedHubItem.id"
      :hub-title="selectedHubItem.attributes.title"
      :hub-description="selectedHubItem.attributes.description"
      :hub-image-u-r-l="selectedHubItem.attributes.image"
      :hub-image-path="null"
      :hub-sharing-settings="selectedHubItem.relationships['sharing-setting'].data.id"
      :hub-auto-share="selectedHubItem.attributes.sync_with_space_members"
      :hub-tags="selectedHubItem.attributes.tags"
      :auto-share-with-activities="selectedHubItem.attributes.auto_share_with_activities"
      @close="visibleDialogHubSettingsDialog= false"
      @proceedSubmit="updateHub"
    />

  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getAllActivities, updateActivity, duplicateActivity} from '../../api/activityApi'
import { getAllHubs, updateHub } from '../../api/hubApi'
import EmptyPage from '../../components/EmptyPage'
import CreateContentTemplate from '../../components/CreateContentTemplate'
import VClamp from 'vue-clamp';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import ConfirmationDialogDuplicateActivity from '../../components/ConfirmationDialogDuplicateActivity'
import CreateContentTemplateDialog from '../../components/CreateContentTemplateDialog';
import ConfirmationDialogCreateTemplate from '../../components/ConfirmationDialogCreateTemplate'
import ConfirmationDialogCreateActivity from '../../components/ConfirmationDialogCreateActivity'
import EditActivity from '../../views/activities/EditActivity'
import EditHub from '../../views/hubs/EditHub'
import DashboardHeader from '../../components/DashboardHeader'
import SearchBarGlobal from '../../components/SearchBarGlobal'
import ListGridViewMode from '../../components/ListGridViewMode.vue'
import ConfirmationDialogWithOutSubmitBtn from '../../components/ConfirmationDialogWithOutSubmitBtn'

export default {
    components: {
        EmptyPage,
        CreateContentTemplate,
        VClamp,
        AlertMessages,
        ConfirmationDialog,
        ConfirmationDialogDuplicateActivity,
        CreateContentTemplateDialog,
        ConfirmationDialogCreateTemplate,
        ConfirmationDialogCreateActivity,
        EditActivity,
        EditHub,
        SearchBarGlobal,
        DashboardHeader,
        ListGridViewMode,
        ConfirmationDialogWithOutSubmitBtn
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            activities: [],
            activitiesInfo: {
                currentPage: 1,
                total: 1,
            },
            hubs: [],
            hubInfo: {
                currentPage: 1,
                total: 1,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            pageNumberHubs: 1,
            pageNumberActivities:1,
            sizeHubs: 5,
            sizeActivities: 5,
            loadingData: false,
            sharingSettingRestricted: i18n.t('sharingSettingRestricted'),
            sharingSettingFlexible: i18n.t('sharingSettingFlexible'),
            sharingSettingOpen: i18n.t('sharingSettingOpen'),
            sharingSettingRestrictedTooltip: i18n.t('sharingSettingRestrictedTooltip'),
            sharingSettingFlexibleTooltip: i18n.t('sharingSettingFlexibleTooltip'),
            sharingSettingOpenTooltip: i18n.t('sharingSettingOpenTooltip'),
            dialogVisibleRemoveActivity: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            dialogVisibleDuplicateActivity: false,
            dialogVisibleRemoveHub: false,
            loadingDuplicateProcess: false,
            dialogVisibleCreateContentTemplate:false,
            dialogVisibleCreateTemplateFromActivity: false,
            dialogVisibleCreateActivity: false,
            visibleDialogActivitySettingsDialog: false,
            visibleDialogHubSettingsDialog: false,
            selectedActivityItem: {},
            selectedHubItem: {},
            view: window.$cookies && window.$cookies.isKey('viewMode') ?  window.$cookies.get('viewMode') : 'grid-view',
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            showConfirmationDialog:false,
            confirmationDialogAdditonalText : '',
            storeProducts:[]
        }
    },
    computed: {
        // sizeHubs() {
        //   switch (this.$vuetify.breakpoint.name) {
        //     case 'xl': return 3
        //     default: return 2
        //   }
        // },
        // sizeActivities() {
        //   switch (this.$vuetify.breakpoint.name) {
        //     case 'xl': return 4
        //     default: return 6
        //   }
        // },
        productPlan() {
          return this.$store.state.productPlan;
        },
    },
    watch: {
     productPlan: {
      immediate: true,
      handler(to) {
        if (to) {
          //handle your changes
            if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
              this.fetchHubs()
          }
        }
      },
    },
  },
  async created(){
        if(this.$route.params.successfullyDowngradedToFreePlan){
            this.alertType = 'success'
            this.alertMsg = i18n.t('downgradeFreePlanSuccess')
            this.alertValue = true
        }
        if(this.$route.params.acceptedInvitationRegistered){
          this.alertMsg = i18n.t('joinSpaceAndRegisterSucccess')
          this.alertType="success"
          this.alertValue = true
        }
        if(this.$route.params.acceptedInvitation){
            this.alertType="success"
            this.alertMsg = i18n.t('joinSpaceSucccess')
            this.alertValue = true
        }
        this.loadingData = true
        if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
            await this.fetchHubs()
        }
        await this.fetchActivities()
        this.loadingData = false
    },
    methods:{
        handlePageChange(value){
            this.activitiesInfo.currentPage = value
            this.pageNumberActivities = value
            this.fetchActivities()
        },
        showhubPage(){
            this.$router.push({path: '/all-hubs'})
        },
        showActivityPage(){
            this.$router.push({path: '/all-activities'}) 
        },
        seeAll(){
            this.$router.push({path: '/dashboard'}) 
        },
        openPeopleInActivity(activityId){
            this.$router.push({path: '/activity/' + activityId + '/overview'})
        },
        openPeopleInHub(hubId){
            this.$router.push({path: '/hub/' + hubId + '/overview'})
        },
        createActivity(){
          this.dialogVisibleCreateActivity = true
        },
        createHub(){
          this.$router.push({path: '/hub/create'})
        },
        openCreateContentDialog(){
          this.dialogVisibleCreateContentTemplate = true
        },
        async fetchActivities(){
            try {
                const response = await getAllActivities(this.spaceId, this.pageNumberActivities, this.sizeActivities)
                if(response.status){
                    if(response.status == 200) {
                        this.activities = response.data.data
                        window.scrollTo(0,0)
                        if(response.data.meta.page){
                            this.activitiesInfo = response.data.meta.page
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeActivity(id){
            this.dialogVisibleRemoveActivity = false
            try{
                let data = {
                    data: {
                        type: "activities",
                        id: id,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            },
                        }
                    }
                }
                const response = await updateActivity(id, data)
                if(response.status == 200) {
                  this.confirmationDialogAdditonalText =''
                    await this.fetchActivities()
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeActivitySuccess')
                }
            } catch (e) {
                if (e.response.status == 403 && e.response.data.errors[0].detail == "It is not allowed to delete an activity used in a product.") {
                     this.storeProducts = e.response.data.errors[0].meta.store_products;
                      this.confirmationDialogAdditonalText =''
                      this.showConfirmationDialogCanNotBeDeleted()
                  } else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
            }
        },
         showConfirmationDialogCanNotBeDeleted(){
           this.storeProducts.forEach(item => {
              this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">  -  ' + item + '</p>';
            });
          this.showConfirmationDialog= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleCanNotBeDeleted')
          this.confirmationDialogText= i18n.t('confirmationDialogTextCanNotBeDeleted')
        },
        async duplicateActivity(title, duplicateOption){
            this.loadingDuplicateProcess = true
            try{
                let data = {
                    data: {
                        type: "activities",
                        id: this.selectedActivityItem.id,
                        attributes: {
                            title: title,
                            keep_published: duplicateOption == 'duplicateAsItIs'? true : false,
                            keep_rules: duplicateOption == 'duplicateAsItIs'? true : false
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            },
                        }
                    }
                }
                const response = await duplicateActivity(this.selectedActivityItem.id, data)
                if(response.status == 201) {
                    if(response.data.data.attributes.top_feed_entity == "page"){
                        this.$router.push({name: 'ViewActivityPage', params: {id: response.data.data.id, pageId: response.data.data.attributes.activity_page_id, successfullyDuplicatedActivity: true}})
                    }else if(response.data.data.attributes.top_feed_entity == "quiz"){
                        this.$router.push({name: 'ViewActivityQuiz', params: {id: response.data.data.id, quizId: response.data.data.attributes.activity_page_id, successfullyDuplicatedActivity: true}})
                    }else if(response.data.data.attributes.top_feed_entity == "scorm"){
                        this.$router.push({name: 'ViewActivityScorm', params: {id: response.data.data.id, scormId: response.data.data.attributes.activity_page_id, successfullyDuplicatedActivity: true}})
                    }else if(response.data.data.attributes.top_feed_entity == "checklist"){
                        this.$router.push({name: 'ViewActivityChecklist', params: {id: response.data.data.id, checklistId: response.data.data.attributes.activity_page_id, successfullyDuplicatedActivity: true}})
                    }else if(response.data.data.attributes.top_feed_entity == "survey"){
                        this.$router.push({name: 'ViewActivitySurvey', params: {id: response.data.data.id, surveyId: response.data.data.attributes.activity_page_id, successfullyDuplicatedActivity: true}})
                    }
                }
            } catch (e) {
              if (e.response.status == 403){
                  for(let i = 0; i < e.response.data.errors.length; i++){
                      if(e.response.data.errors[i].detail == 'Storage is full'){
                        this.dialogVisibleDuplicateActivity = false
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('storageFullError')
                      }
                      else {
                          this.$router.push({name: 'PageAccessDenied'})
                      }
                  }     
              }else {
                  this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
              }
            }
            this.loadingDuplicateProcess = false
        },
        async fetchHubs(){
            try {
                const response = await getAllHubs(this.spaceId, this.pageNumberHubs, this.sizeHubs)
                if(response.status){
                    if(response.status == 200) {
                        this.hubs = response.data.data
                        window.scrollTo(0,0)
                        if(response.data.meta.page){
                            this.hubsInfo = response.data.meta.page
                        }
                        
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async removeHub(id){
            this.dialogVisibleRemoveHub = false
            try{
                let data = {
                    data: {
                        type: "hubs",
                        id: id,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            },
                        }
                    }
                }
                const response = await updateHub(id, data)
                if(response.status == 200) {
                  this.confirmationDialogAdditonalText =''
                    await this.fetchHubs()
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeHubSuccess')
                }
            } catch (e) {
                
                if(e.response){
                   if (e.response.status == 403 && e.response.data.errors[0].detail == "It is not allowed to delete a hub used in a product.") {
                      this.storeProducts = e.response.data.errors[0].meta.store_products;
                      this.confirmationDialogAdditonalText =''
                      this.showConfirmationDialogCanNotBeDeleted()
                  } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                  }
                }
            }
        },
        createTemplate(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.dialogVisibleCreateTemplateFromActivity = false
        },
        createActivityMsg(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.dialogVisibleCreateActivity = false
        },
        createContentMsg(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.dialogVisibleCreateContentTemplate = false
        },
        openActivitySettingsDialog(item){
            this.selectedActivityItem=item
            this.visibleDialogActivitySettingsDialog = true
        },
        async updateActivity(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            await this.fetchActivities()
        },
        openHubSettingsDialog(item){
            this.selectedHubItem=item
            this.visibleDialogHubSettingsDialog = true
        },
        async updateHub(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            await this.fetchHubs()
        },
        toggleView(view){
          this.view = view
        }
    }
}

</script>
<style>
.closed{
  max-width: 55px; 
}
.closed .v-input__slot{
  cursor: pointer !important;
}
.v-input.expanding-search.closed .v-input__append-inner{
  margin-left: -10px;
}
.expanding-search.v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: none !important;
}
.v-input.expanding-search .v-input__control > .v-input__slot{
  padding: 0 14px;
}



.item-title {
  flex-grow: 1;
  margin-right: 8px;
}

</style>

